import { HttpClient } from "@angular/common/http";
import { IUserRole } from "./user-role";
import { Injectable } from "@angular/core";
import { PermissionType } from "./permission";
import { EnvironmentService } from "../services/environment.service";

@Injectable({
    providedIn: 'root'
  })
export class RolePermissionService {
    public static userRole: IUserRole = {
      id: 0,
      name: '',
      permissions:[]
    };
    private fullPath: string;
    constructor(private readonly httpClient: HttpClient, 
      public envService: EnvironmentService) {
        this.fullPath = `${envService?.settings?.apiUrl}/userRoles`;
     }

     public initiateUserRole() {
          this.httpClient.get<IUserRole[]>(this.fullPath).subscribe(x => RolePermissionService.userRole = x[0]);
     }

     public getPermission(name: string): PermissionType {
        const permission =  RolePermissionService?.userRole?.permissions ? RolePermissionService.userRole.permissions.find(x => x.name === name):undefined;
        return permission ? permission.value : PermissionType.none;
     }

     public userHasPermission(name: string): boolean {
        const permission =  RolePermissionService?.userRole?.permissions ? RolePermissionService.userRole.permissions.find(x => x.name.toLowerCase() == name.toLowerCase()) : undefined;
        return permission ? true : false;
     }
}